import { css } from 'styled-components';
import { memoizeFunction } from '@agilepoint/utils-common';

export const createBaseColumnRules = memoizeFunction((noGutter?: boolean) => css`
        box-sizing: border-box;
        padding: ${noGutter ? 0 : '0 0.5rem 1rem'};
    `);

export const createColumnsRules = memoizeFunction((columnsCount: number) => {

    const columnWidth = 100 / columnsCount;
    const classes: { [key: string]: any; } = {};
    let currentColumn = 1;
    while (currentColumn <= columnsCount) {

        const width = `${columnWidth * currentColumn}%`;

        if (columnsCount !== currentColumn) {
            classes[`columnOffsetLeft_${currentColumn}`] = css`
                margin-left: ${width};
            `;
            classes[`columnOffsetRight_${currentColumn}`] = css`
                margin-right: ${width};
            `;
        }

        classes[`column_${currentColumn}`] = css`
            max-width: ${width};
            flex-basis: ${width};
        `;
        ++currentColumn;
    }
    return classes;
});

export const createColumnClasses = memoizeFunction((columnsCount: number, noGutter?: boolean) => {
    const columsRules = createColumnsRules(columnsCount);
    const baseColumnRules = createBaseColumnRules(noGutter);
    return { column_base: baseColumnRules, ...columsRules };
});
